module.exports = __webpack_public_path__ + "img/20211120-146.00451569.jpg";